const now = new Date();

export type PointCategory = {
  categoryId: number,
  categoryName: string,
  sortKey: number,
};
 
 export type PointHistoryData = {
  id: string,
  tenantId: string,
  userId: string,
  displayUserId: string,
  userName: string,
  tranType: string,
  ptSettingId?: string,
  ptCategoryId?: number,
  ptCategoryName?: string,
  ptTypeId?: string,
  ptTypeName?: string,
  ptName?: string,
  grantPoints: number,
  heldPoints?: number,
  isBonus: boolean,
  occurrenceDate: Date,
  grantFlg?: boolean,
  grantDate?: Date,
  expirationDate?: Date,
  note?: string,
  eventMsgId?: string,
  createAt: Date,
  updateAt: Date,
  expirationFlg: boolean,
}

// ポイント履歴の初期値
export const newPointHistory = (): PointHistoryData => {
  return {
    id: "",
    tenantId: "",
    userId: "",
    displayUserId: "",
    userName: "",
    tranType: "",
    ptSettingId: "",
    ptCategoryId: 0,
    ptCategoryName: "",
    ptTypeId: "",
    ptTypeName: "",
    ptName: "",
    grantPoints: 0,
    heldPoints: 0,
    isBonus: false,
    occurrenceDate: now,
    grantFlg: false,
    grantDate: now,
    expirationDate: now,
    note: "",
    eventMsgId: "",
    createAt: now,
    updateAt: now,
    expirationFlg: false,
  };
};

export const pointDataTimestampToDate = (data: any | undefined): PointHistoryData => {
  if(data.occurrenceDate !== null){
    const occurrenceDate = new Date(data.occurrenceDate.seconds * 1000);
    data.occurrenceDate = new Date(occurrenceDate.getFullYear(), occurrenceDate.getMonth(), occurrenceDate.getDate(), occurrenceDate.getHours(), occurrenceDate.getMinutes(), occurrenceDate.getSeconds());
  }
  if(data.grantDate && data.grantDate !== null){
    const grantDate = new Date(data.grantDate.seconds * 1000);
    data.grantDate = new Date(grantDate.getFullYear(), grantDate.getMonth(), grantDate.getDate(), grantDate.getHours(), grantDate.getMinutes(), grantDate.getSeconds());
  }
  if(data.expirationDate && data.expirationDate !== null){
    const expirationDate = new Date(data.expirationDate.seconds * 1000);
    data.expirationDate = new Date(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate());
  }
  if(data.createAt !== null){
    const createAt = new Date(data.createAt.seconds * 1000);
    data.createAt = new Date(createAt.getFullYear(), createAt.getMonth(), createAt.getDate(), createAt.getHours(), createAt.getMinutes(), createAt.getSeconds());
  }
  if(data.updateAt !== null){
    const updateAt = new Date(data.updateAt.seconds * 1000);
    data.updateAt = new Date(updateAt.getFullYear(), updateAt.getMonth(), updateAt.getDate(), updateAt.getHours(), updateAt.getMinutes(), updateAt.getSeconds());
  }
  return data;
};
